// @flow
import moment from 'moment';
import DateRange from 'common/domain/DateRange';
import Advertiser from '../../advertiser/domain/Advertiser';

type SalesPromotionData = {
  reference: string;
  campaignReference: string;
  title: string;
  advertiser: Advertiser;
  nbOfSpots: number;
  cost: number;
  discount: number;
  dateRange: DateRange;
  expirationDate: moment;
  state: SalesPromotionState;
};

export type SalesPromotionState = 'PROPOSED' | 'ACCEPTED' | 'DECLINED';
export const STATES: SalesPromotionState[] = ['PROPOSED', 'ACCEPTED', 'DECLINED'];
export const PARSED_DATE_FORMAT = 'YYYY-MM-DD';

class SalesPromotion {

  reference: string;
  campaignReference: string;
  title: string;
  nbOfSpots: number;
  cost: number;
  discount: number;
  dateRange: DateRange;
  expirationDate: moment;
  state: SalesPromotionState;
  advertiser: Advertiser;

  constructor({ reference, campaignReference, title, advertiser, nbOfSpots, cost, discount, dateRange, expirationDate, state }: SalesPromotionData) {
    this.reference = reference;
    this.campaignReference = campaignReference;
    this.title = title;
    this.advertiser = advertiser;
    this.nbOfSpots = nbOfSpots;
    this.cost = cost;
    this.discount = discount;
    this.dateRange = dateRange;
    this.expirationDate = expirationDate;
    this.state = state;
  }

  getReference(): string {
    return this.reference;
  }

  getAdvertiser(): Advertiser {
    return this.advertiser;
  }

  getTitle(): string {
    return this.title;
  }

  getFromDate(): moment {
    return this.dateRange.from;
  }

  getToDate(): moment {
    return this.dateRange.to;
  }

  getDateRange(): DateRange {
    return this.dateRange;
  }

  getCost(): number {
    return this.cost;
  }

  getNumberOfSpots(): number {
    return this.nbOfSpots;
  }

  getDiscount(): number {
    return this.discount;
  }

  getExpirationDate(): moment {
    return this.expirationDate;
  }

  isInState(state: SalesPromotionState): boolean {
    return this.state === state;
  }

  isSame(other: SalesPromotion): boolean {
    return this.reference === other.reference;
  }

  static parse(data: Object): SalesPromotion {
    const expirationDate = moment(data.expirationDate, PARSED_DATE_FORMAT);
    const from = moment(data.from, PARSED_DATE_FORMAT);
    const to = moment(data.to, PARSED_DATE_FORMAT);

    const dateRange = new DateRange({ from, to });
    const advertiser = Advertiser.parse(data.customer);
    const promotionData = { ...data, expirationDate, dateRange, advertiser };

    return new SalesPromotion(promotionData);
  }
}

export default SalesPromotion;



// WEBPACK FOOTER //
// ./src/common/modules/sales/domain/SalesPromotion.js